module.exports = __webpack_public_path__ + "/f4920c94c0861c537f72ba36590f6362.woff";